import { RefreshCw } from 'lucide-react';
import { cn } from '../utils/cn';

type LoadingSpinnerProps = {
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  'aria-label'?: string;
};

const sizeClasses: Record<NonNullable<LoadingSpinnerProps['size']>, string> = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-12 h-12',
};

export function LoadingSpinner({
  className,
  size = 'md',
  'aria-label': ariaLabel,
}: LoadingSpinnerProps) {
  return (
    <RefreshCw
      className={cn('animate-spin text-gray-400', sizeClasses[size], className)}
      aria-label={ariaLabel ?? 'Loading'}
    />
  );
}
